import React from 'react';
import classNames from 'classnames';

// Higher Order Components
import Dropzone from 'react-dropzone';

import s from './ImageDropzone.module.scss';

const ImageDropzone = ({ onFileDrop, multiple, acceptedFileTypes, maxFileSize, disabled }) => {
    const onDrop = (accepted, rejected) => onFileDrop({ accepted, rejected });

    return (
        <Dropzone
            disabled={disabled}
            accept={acceptedFileTypes}
            onDrop={onDrop}
            maxSize={maxFileSize} // Max accepted size: 5MB
            multiple={multiple}
        >
            {({ getRootProps, getInputProps }) => (
                <div className={classNames(s.uploader, s.imgChildContainer)} {...getRootProps()} data-testid={'image-dropzone'}>
                    <input {...getInputProps()} />
                    <div className={s.imgContainer}>
                        <div className={s.circleBg}>
                            <img
                                className={classNames(s.uploadImgHoverFan, s.leftFan)}
                                src="https://content.locuslabs.com/vms-ui/placeholder-icons/image-placeholder-icon-side.svg"
                                alt="Uploader Hover Left"
                            />
                            <img
                                className={classNames(s.uploadImgHoverFan, s.rightFan)}
                                src="https://content.locuslabs.com/vms-ui/placeholder-icons/image-placeholder-icon-side.svg"
                                alt="Uploader Hover Right"
                            />
                            <img className={s.uploadImg} src="https://content.locuslabs.com/vms-ui/placeholder-icons/image-placeholder-icon.svg" alt="Uploader" />
                            <img className={s.uploadImgHover} src="https://content.locuslabs.com/vms-ui/placeholder-icons/image-placeholder-icon-blue.svg" alt="Uploader Hover" />
                        </div>
                    </div>
                    <div className={s.uploadPrompt}>
                        Drag or
                        {<span className={s.browseClick}>browse</span>}
                        to upload
                    </div>
                </div>
            )}
        </Dropzone>
    );
};

export default ImageDropzone;
